import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Modal from "@amzn/meridian/modal";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Loader from "@amzn/meridian/loader";
import Alert from "@amzn/meridian/alert";

import { keys } from "i18n";
import { deleteYardMap, clearErrorDeletingYardMap } from "store";
import { generateErrorMessage } from "../../helpers";

function DeleteYardMapDialog({ yardId, version, onClose }) {
  const dispatch = useDispatch();
  const { deletingYardMap, errorDeletingYardMap } = useSelector((state) => state.yardMapData);
  const { t } = useTranslation();

  const handleConfirmDelete = () => {
    dispatch(deleteYardMap(yardId, version));
  };

  const handleClose = () => {
    if (errorDeletingYardMap) {
      dispatch(clearErrorDeletingYardMap());
    }
    onClose();
  };

  return (
    <Modal width="400px" bodySpacingInset="medium" title={t(keys.DELETE_MAP)} open={true}>
      <Text data-testid={"confirm-map-deletion-label"}>{t(keys.DELETE_MAP_CONFIRMATION)}</Text>

      <Row alignmentHorizontal="right" spacingInset="large none none none">
        <Button
          type="secondary"
          minWidth="80px"
          disabled={deletingYardMap}
          onClick={handleClose}
          data-testid={"cancel-button"}
        >
          {t(keys.CANCEL)}
        </Button>

        {deletingYardMap ? (
          <Loader size="medium" />
        ) : (
          <Button type="primary" minWidth="90px" onClick={handleConfirmDelete}>
            {t(keys.DELETE_MAP)}
          </Button>
        )}
      </Row>

      {errorDeletingYardMap && (
        <Row alignmentHorizontal="right" spacingInset="medium none">
          <Alert size="small" type="error">
            {generateErrorMessage(t(keys.DELETE_MAP_ERROR_MESSAGE), errorDeletingYardMap)}
          </Alert>
        </Row>
      )}
    </Modal>
  );
}

DeleteYardMapDialog.propTypes = {
  yardId: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteYardMapDialog;
